import type { PropsWithChildren } from 'react';

import * as S from './Sku.styles';

export const Sku = ({ children }: PropsWithChildren) => {
  return <S.Sku data-test-id='Sku'>{children}</S.Sku>;
};

Sku.displayName = 'Sku';
